module.exports = "/images/interface-02.png?581f62098cff345bcb38aa1cb8cfaec8";